import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2beaecf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-block" }
const _hoisted_2 = { class: "block-title" }
const _hoisted_3 = {
  class: "row cm-ui-mt15",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  class: "row cm-ui-mt15",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "cm-ui-ml15" }
const _hoisted_8 = { class: "row cm-ui-mt30" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "baseline-scan-item-box" }
const _hoisted_11 = { class: "cm-ui-ml15" }
const _hoisted_12 = {
  key: 0,
  class: "cm-ui-mb15 cm-ui-mt20",
  style: {"padding-left":"1px"}
}
const _hoisted_13 = { class: "scan-item-drawer-title-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_MixSelectors = _resolveComponent("MixSelectors")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ScanItemDrawer = _resolveComponent("ScanItemDrawer")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (+_ctx.systemTab === _ctx.TerminalType.linux)
      ? (_openBlock(), _createBlock(_component_DetailsSubscribeBar, {
          key: 0,
          "linux-permission-key": _ctx.PermissionFe.linux_base_auth
        }, null, 8, ["linux-permission-key"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container cm-ui-ml10" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.baseEnableScheduledScan')), 1),
            _createVNode(_component_el_switch, {
              modelValue: _ctx.strategy.main_switch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.main_switch) = $event)),
              class: "cm-ui-ml15",
              onChange: _ctx.setChangeStatus
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: "row-label cm-ui-mr15",
            style: {"padding":"0"},
            title: _ctx.t('groupPolicySettings.schedFreqLabel')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.schedFreqLabel')), 1)
          ], 8, _hoisted_4),
          _createVNode(_component_el_select, {
            size: "small",
            modelValue: _ctx.strategy.frequency,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.frequency) = $event)),
            disabled: !_ctx.strategy.main_switch,
            class: "cm-ui-ml15",
            onChange: _ctx.changeFrequency
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                type: 1,
                label: _ctx.t('softwareDisabledEdit.freqDaily'),
                value: 1
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                type: 2,
                label: _ctx.t('softwareDisabledEdit.freqWeekly'),
                value: 2
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                type: 3,
                label: _ctx.t('softwareDisabledEdit.freqMonthly'),
                value: 3
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            class: "row-label cm-ui-mr15",
            title: _ctx.t('groupPolicySettings.schedTimeLabel')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.schedTimeLabel')), 1)
          ], 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_MixSelectors, {
              "main-switch": _ctx.strategy.main_switch,
              "mix-type": _ctx.strategy.frequency,
              "s-key": "baseLineSelectors"
            }, null, 8, ["main-switch", "mix-type"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            class: "row-label cm-ui-mr15",
            title: _ctx.t('groupPolicySettings.basePickScanItemsLabel')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.basePickScanItemsLabel')), 1)
          ], 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.baseScanTotalPrefix')) + " ", 1),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.openScanItemDrawer
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data.totalItemsCount), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createTextVNode(" " + _toDisplayString(_ctx.t('groupPolicySettings.baseScanItemsMid')) + " ", 1),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.openScanItemDrawer
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data.scanItemSelectCount), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createTextVNode(" " + _toDisplayString(_ctx.t('groupPolicySettings.baseScanItemsSuffix')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              plain: "",
              onClick: _ctx.openScanItemDrawer
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.baseSelectScanItemsBtn')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        (_ctx.operateType !== _ctx.OperateType.read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: _ctx.handleSaveBaselineScanSetting,
                disabled: !_ctx.hasPermission
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_drawer, {
          size: 1500,
          modelValue: _ctx.data.scanItemDrawer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.scanItemDrawer) = $event)),
          direction: "rtl",
          "destroy-on-close": "",
          "before-close": _ctx.handleScanDrawerClose
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.baseDrawerSelectTitle')) + " ", 1),
              _createVNode(_component_el_button, { type: "text" }, {
                default: _withCtx(() => [
                  _createTextVNode("(" + _toDisplayString(_ctx.data.scanItemSelectCount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { type: "text" }, {
                default: _withCtx(() => [
                  _createTextVNode("/ " + _toDisplayString(_ctx.data.totalItemsCount) + ")", 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ScanItemDrawer, {
              onHandleScanDrawerClose: _ctx.handleScanDrawerClose,
              scan_type: _ctx.data.scanType,
              operateType: _ctx.operateType,
              scan_items_id: _ctx.data.scan_item_ids,
              system_tab: _ctx.systemTab,
              scan_item_custom: _ctx.strategy.scan_item_custom
            }, null, 8, ["onHandleScanDrawerClose", "scan_type", "operateType", "scan_items_id", "system_tab", "scan_item_custom"])
          ]),
          _: 1
        }, 8, ["modelValue", "before-close"])
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}